// extracted by mini-css-extract-plugin
export var chevronIcon = "_bd-2";
export var teamName = "_bd-1";
export var teamSwitcherButton = "_bd-0";